// Actions
const PREFIX = 'calculus/user/';

export const USER_PATCH  = PREFIX + 'USER_PATCH';
export const USER_SETTINGS_PATCH  = PREFIX + 'USER_SETTINGS_PATCH';

export const USER_LOG_IN  = PREFIX + 'USER_LOG_IN';
export const USER_LOG_OUT  = PREFIX + 'USER_LOG_OUT';

export const PROJECT_SAVE_TO_SERVER  = PREFIX + 'PROJECT_SAVE_TO_SERVER';
export const PROJECT_PATCH_TO_SERVER  = PREFIX + 'PROJECT_PATCH_TO_SERVER';
export const PROJECT_DELETE_FROM_SERVER  = PREFIX + 'PROJECT_DELETE_FROM_SERVER';

export const CUSTOM_CREATE_TO_SERVER  = PREFIX + 'CUSTOM_CREATE_TO_SERVER';
export const CUSTOM_PATCH_TO_SERVER  = PREFIX + 'CUSTOM_PATCH_TO_SERVER';
export const CUSTOM_DELETE_FROM_SERVER  = PREFIX + 'CUSTOM_DELETE_FROM_SERVER';


const INITIAL_STATE = {
  username: null,
  language: null,
  uid: null,

  logInProgress: false,
  logOutProgress: false,
  logInError: false,
  logInErrorMsg: null,
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case USER_PATCH:
      return {
        ...state,
        ...payload,
      };

    case USER_SETTINGS_PATCH:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...payload
        }
      };

    case USER_LOG_IN:
      // Set username and logging false
      return {
        ...state,
        logInProgress: false,
        logInError: false,
        logInErrorMsg: null,
        ...payload
      };

      case USER_LOG_OUT:
        // Set username and logging false
        return {
          ...state,
          ...payload
        };

    default:
      return state;
  }
}

// Action Creators
export function patchUser(payload) {
  return {
    type: USER_PATCH,
    payload: payload
  };
}

export function patchSettings(payload) {
  return {
    type: USER_SETTINGS_PATCH,
    payload: payload
  };
}

export function logIn(payload) {
  return {
    type: USER_LOG_IN,
    payload: payload
  };
}

export function logOut(payload) {
  return {
    type: USER_LOG_OUT,
    payload: payload
  };
}

export function projectSaveToServer(payload = null) {
  return {
    type: PROJECT_SAVE_TO_SERVER,
    payload: payload
  };
}

export function projectPatchToServer(payload = null) {
  return {
    type: PROJECT_PATCH_TO_SERVER,
    payload: payload
  };
}

export function projectDeleteFromServer(payload = null) {
  return {
    type: PROJECT_DELETE_FROM_SERVER,
    payload: payload
  };
}

export function customItemSaveToServer(payload = null) {
  return {
    type: CUSTOM_CREATE_TO_SERVER,
    payload: payload
  };
}

export function customItemPatchToServer(payload = null) {
  return {
    type: CUSTOM_PATCH_TO_SERVER,
    payload: payload
  };
}

export function customItemDeleteFromServer(payload = null) {
  return {
    type: CUSTOM_DELETE_FROM_SERVER,
    payload: payload
  };
}
